import React, { Component } from 'react'
import ReactPlayer from 'react-player'
import { PrimaryH3, SecondaryP } from './styled-components.js'

export default class Video extends Component {
  constructor() {
    super()
    this.state = {
      showOverlay: true,
    }
  }

  hideOverlay = () => {
    this.setState({
      showOverlay: false,
    })
  }

  render() {
    const { component } = this.props
    const { showOverlay } = this.state
    const isFullPage = component.columnWidth === 'full-page'
    const alignmentAndWidth = isFullPage
      ? ''
      : component.alignment + ' ' + component.columnWidth
    const isPlaying = !showOverlay
    const poster = {
      backgroundImage: `url(https:${component.vimeoPosterImage.file.url})`,
    }
    const posterOverlayColor = {
      backgroundColor: `${component.posterOverlayColor}`,
    }

    return (
      <section className={`component video margin-${component.marginBelow}`}>
        <div className={`grid-row ${isFullPage ? 'full-page' : ''}`}>
          <figure className={`video-block ${alignmentAndWidth}`}>
            <div className="video-content">
              {showOverlay && (
                <div className="overlay" onClick={this.hideOverlay}>
                  <div className="play-button" />
                  <div className="color-overlay" style={posterOverlayColor} />
                  <div className="poster-image" style={poster} />
                </div>
              )}
              <div className="wrapper">
                <ReactPlayer
                  className="react-player"
                  url={component.vimeoUrl}
                  playing={isPlaying}
                  width="100%"
                  height="100%"
                />
              </div>
            </div>
          </figure>
        </div>

        {(component.captionTitle || component.captionCopy) && (
          <div className="grid-row">
            <figcaption
              className={`video-caption caption-${component.captionAlignment}`}
            >
              {component.captionTitle && (
                <PrimaryH3 primaryTextColor={component.primaryColor}>
                  {component.captionTitle}
                </PrimaryH3>
              )}
              {component.captionCopy && (
                <SecondaryP
                  secondaryTextColor={component.secondaryColor}
                  dangerouslySetInnerHTML={{
                    __html: component.captionCopy.captionCopy,
                  }}
                />
              )}
            </figcaption>
          </div>
        )}
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/shared-page-components/video.js